import { Component, OnDestroy, OnInit } from "@angular/core";
import { Meta } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import { TranslocoService } from "@ngneat/transloco";
import { GeneralService } from "app/services/general.service";
import { HreflangService } from "app/services/hreflang.service";
import { NewsClass } from "app/shared/news";
import { Observable, Subscription, of } from "rxjs";
import { catchError, shareReplay } from "rxjs/operators";

@Component({
  selector: "app-news",
  templateUrl: "./news.component.html",
  styleUrls: ["./news.component.scss"],
})
export class NewsComponent implements OnInit, OnDestroy {
  news$: Observable<NewsClass[]>;
  activeLang = "EN";
  firstRun = false;
  private langChangesSubscription: Subscription;

  errorMsg: string | null = null;

  constructor(
    public router: ActivatedRoute,
    private _translocoService: TranslocoService,
    private meta: Meta,
    private generalService: GeneralService,
    private hreflangService: HreflangService
  ) {}

  ngOnInit(): void {
    this.news$ = this.generalService.getItems("news").pipe(
      catchError((err) => {
        this.errorMsg = (err && (err.message || err.statusText)) || "Error";
        // نرجّع مصفوفة فاضية حتى ما ينهار القالب
        return of([] as NewsClass[]);
      }),
      shareReplay(1)
    );
    this.getActiveLang();
  }

  getActiveLang() {
    this.langChangesSubscription =
      this._translocoService.langChanges$.subscribe((activeLang) => {
        if (this.activeLang !== activeLang || !this.firstRun) {
          this.deleteSchemaMeta();
          setTimeout(() => {
            this.hreflangService.updateHreflangTags(activeLang, "news");
          }, 1000);
          this.firstRun = true;
        }
        this.activeLang = activeLang;
      });
  }

  ngOnDestroy() {
    if (this.langChangesSubscription)
      this.langChangesSubscription.unsubscribe();
    // Delete Robots
    const robotTags = this.meta.getTags('name="robots"');
    robotTags.forEach((tag) => {
      try {
        this.meta.removeTagElement(tag);
      } catch {}
    });
    this.deleteSchemaMeta();
  }

  deleteSchemaMeta() {
    // Delete Hreflang
    const hreflangTags = this.meta.getTags('name="hreflang"');
    hreflangTags.forEach((tag) => {
      try {
        this.meta.removeTagElement(tag);
      } catch {}
    });
    // Delete Canonical
    try {
      this.meta.removeTag("rel=canonical");
    } catch {}
  }
}
